import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { InputField } from '../../../../common/Inputs';
import { FormColumn, FormRow } from '../../../../common/LayoutComponents';
import { RouteFormState } from '../../../Common';

const testIds = {
  originFinnishNameInput: 'TerminusNameInputs::origin::finnishNameInput',
  originFinnishShortNameInput:
    'TerminusNameInputs::origin::finnishShortNameInput',
  originSwedishNameInput: 'TerminusNameInputs::origin::swedishNameInput',
  originSwedishShortNameInput:
    'TerminusNameInputs::origin::swedishShortNameInput',
  destinationFinnishNameInput:
    'TerminusNameInputs::destination::finnishNameInput',
  destinationFinnishShortNameInput:
    'TerminusNameInputs::destination::finnishShortNameInput',
  destinationSwedishNameInput:
    'TerminusNameInputs::destination::swedishNameInput',
  destinationSwedishShortNameInput:
    'TerminusNameInputs::destination::swedishShortNameInput',
};

type TerminusNameInputsProps = {
  readonly className?: string;
};

export const TerminusNameInputs: FC<TerminusNameInputsProps> = ({
  className,
}) => {
  const { t } = useTranslation();
  return (
    <div className={twMerge('w-full px-4', className)}>
      <h3 className="my-4 w-full pt-1">{t(($) => $.routes.origin.title)}</h3>
      <FormColumn>
        <FormRow
          className="items-end sm:gap-x-4 md:gap-x-4 lg:gap-x-4"
          mdColumns={2}
        >
          <InputField<RouteFormState>
            type="text"
            translationPrefix="routes"
            fieldPath="origin.name.fi_FI"
            testId={testIds.originFinnishNameInput}
            required
          />
          <InputField<RouteFormState>
            type="text"
            translationPrefix="routes"
            fieldPath="origin.shortName.fi_FI"
            testId={testIds.originFinnishShortNameInput}
            required
          />
          <InputField<RouteFormState>
            type="text"
            translationPrefix="routes"
            fieldPath="origin.name.sv_FI"
            testId={testIds.originSwedishNameInput}
            required
          />
          <InputField<RouteFormState>
            type="text"
            translationPrefix="routes"
            fieldPath="origin.shortName.sv_FI"
            testId={testIds.originSwedishShortNameInput}
            required
          />
        </FormRow>
      </FormColumn>
      <h3 className="my-4 w-full pt-1">
        {t(($) => $.routes.destination.title)}
      </h3>
      <FormColumn>
        <FormRow
          className="items-end sm:gap-x-4 md:gap-x-4 lg:gap-x-4"
          mdColumns={2}
        >
          <InputField<RouteFormState>
            type="text"
            translationPrefix="routes"
            fieldPath="destination.name.fi_FI"
            testId={testIds.destinationFinnishNameInput}
            required
          />
          <InputField<RouteFormState>
            type="text"
            translationPrefix="routes"
            fieldPath="destination.shortName.fi_FI"
            testId={testIds.destinationFinnishShortNameInput}
            required
          />
          <InputField<RouteFormState>
            type="text"
            translationPrefix="routes"
            fieldPath="destination.name.sv_FI"
            testId={testIds.destinationSwedishNameInput}
            required
          />
          <InputField<RouteFormState>
            type="text"
            translationPrefix="routes"
            fieldPath="destination.shortName.sv_FI"
            testId={testIds.destinationSwedishShortNameInput}
            required
          />
        </FormRow>
      </FormColumn>
    </div>
  );
};
